import { useEffect, useState } from "react";
import api from "../lib/api";
import { Plus, Robot } from "@phosphor-icons/react";
import { Button } from "../components/ui/button";
import { AssistantChat } from "../components/AssistantChat";

export default function AssistantPage() {
  const [sessions, setSessions] = useState([]);
  const [sid, setSid] = useState(undefined);
  const [starter, setStarter] = useState("");

  const STARTERS = [
    "A caregiver missed EVV again — how should I handle it?",
    "A client fell but seems fine and the family says not to worry — what do I do?",
    "A family disputes what a caregiver's wrap-up says. What are my options?",
    "A caregiver keeps skipping a task code that's on the plan — entry habit or has the care changed?",
    "What do I need to document when a client refuses a planned task?",
    "I'm not sure how to handle a situation with a caregiver — walk me through it.",
  ];

  const loadSessions = async () => {
    try {
      const { data } = await api.get("/assistant/sessions");
      setSessions(data.sessions || []);
    } catch { /* sidebar is optional */ }
  };

  useEffect(() => { loadSessions(); }, [sid]);

  return (
    <div className="flex h-[calc(100vh-8rem)] gap-4" data-testid="assistant-page">
      <aside className="hidden w-60 shrink-0 flex-col rounded-lg border border-stone-200 bg-white shadow-sm md:flex" data-testid="assistant-sidebar">
        <div className="border-b border-stone-200 p-3">
          <Button onClick={() => setSid(null)} variant="outline" className="w-full border-stone-300" data-testid="assistant-new-chat"><Plus size={15} className="mr-1.5" /> New chat</Button>
        </div>
        <div className="flex-1 overflow-y-auto p-2">
          {sessions.map((s) => (
            <button key={s.id} onClick={() => setSid(s.id)}
              className={`mb-1 block w-full truncate rounded px-2.5 py-2 text-left text-xs ${s.id === sid ? "bg-accent font-semibold text-accent-foreground" : "text-stone-600 hover:bg-accent/50"}`}
              data-testid={`assistant-session-${s.id}`}>
              {s.title || "Untitled chat"}
            </button>
          ))}
          {sessions.length === 0 && <p className="p-2 text-xs text-stone-400">No past chats yet.</p>}
        </div>
      </aside>

      <section className="flex min-w-0 flex-1 flex-col rounded-lg border border-stone-200 bg-white shadow-sm">
        <div className="border-b border-stone-200 p-4">
          <h1 className="font-heading text-xl font-semibold text-stone-900">Assistant</h1>
          <p className="mt-0.5 text-xs text-stone-500">Checks your knowledge base first, then general guidance — it advises, you decide. Before it changes anything, you&rsquo;ll review a card and Confirm.</p>
          <div className="mt-2.5 flex flex-wrap gap-1.5" data-testid="assistant-starters">
            {STARTERS.map((s, i) => (
              <button key={i} onClick={() => setStarter(`${s} `)}
                className="rounded-full border border-stone-200 bg-stone-50 px-3 py-1 text-[11px] text-stone-600 transition-colors hover:border-primary/40 hover:bg-primary/5 hover:text-primary"
                data-testid={`assistant-starter-${i}`}>{s}</button>
            ))}
          </div>
        </div>
        <AssistantChat sid={sid} onSidChange={setSid} starter={starter} />
      </section>
    </div>
  );
}
